import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { useTheme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import HeroImg from 'images/icons/smp_hero.svg'
import SchufaLogo from 'images/logos/schufa_logo.svg'
import VrLogo from 'images/logos/vr_logo_with_text.svg'
import React, { FC, Fragment } from 'react'
import { scopedTranslation } from 'src/helpers'

import { RegisterButton } from '../RegisterButton/RegisterButton'
import { CheckBulletPoint } from './CheckBulletPoint'
import { useStyles } from './HeroSection.styles'

const { t } = scopedTranslation('component.smp.landing_page.hero_section')

export const HeroSection: FC = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Fragment>
      <Grid container={ true } alignItems='center' direction={ isMobileScreen ? 'column-reverse' : 'row' }>
        <Grid item={ true } xs={ 12 } md={ 6 }>
          <Box mt={ 4 } className={ classes.headline }>
            <Typography variant='h1'>{ t('headline') }</Typography>
          </Box>
          <Box my={ 2 }>
            <Typography><Box fontWeight='bold'>{ t('sub_header') }</Box></Typography>
          </Box>
          <CheckBulletPoint message={ t('catch_phrase_html') } />
          <CheckBulletPoint message={ t('insights_credit_rating') } />
          <CheckBulletPoint message={ t('insights_security_transparency') } />
          <Box mt={ 4 } mb={ 5 }>
            <RegisterButton buttonKey='call-to-action-high' />
          </Box>
        </Grid>
        <Grid item={ true } xs={ 12 } md={ 6 } className={ classes.heroImageColumn }>
          <Box position='relative' className={ classes.heroImageContainer }>
            <img src={ HeroImg } alt='' className={ classes.heroImage } />
          </Box>
        </Grid>
      </Grid>
      <Box py={ 2 }>
        <img src={ VrLogo } alt={ t('vr_alt_text') } className={ classes.logoImage } />
        <img src={ SchufaLogo } alt={ t('schufa_alt_text') } className={ classes.logoImage } />
      </Box>
    </Fragment>
  )
}
